// UTM and attribution capture. Persists the *first-touch* source for the session,
// then provides it to the LeadForm on submit.
const KEY = 'spec_attribution_v1';

const PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];

const readStored = () => {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const writeStored = (data) => {
  try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch { /* ignore */ }
};

// Run once per session as soon as the app boots. If UTM params are present in the
// current URL, they win; otherwise we fall back to whatever we already stored.
export const captureAttribution = () => {
  const existing = readStored();
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    for (const k of PARAMS) {
      const v = params.get(k);
      if (v) utm[k] = v.slice(0, 200);
    }
    const hasNew = Object.keys(utm).length > 0;
    if (!existing || hasNew) {
      const payload = {
        ...(existing || {}),
        ...utm,
        landing_page: existing?.landing_page || (window.location.pathname + window.location.search).slice(0, 500),
        referrer: existing?.referrer || (document.referrer || '').slice(0, 500),
        captured_at: existing?.captured_at || new Date().toISOString(),
      };
      writeStored(payload);
      return payload;
    }
    return existing;
  } catch {
    return existing;
  }
};

export const getAttribution = () => readStored() || captureAttribution();
